import { RootState } from "../reducers";
import { TempLayerState } from "./tempLayer";

export const getTempLayerSourceName = ({ tempLayer }: RootState): string => tempLayer.sourceName;

export const getTempLayerInfo = ({ tempLayer }: RootState): TempLayerState["layerInfo"] => tempLayer.layerInfo;

export const getTempLayerError = ({ tempLayer }: RootState): TempLayerState["error"] => tempLayer.error;
